import { oidcLogoutSchema, oidcStatusSchema } from "@peer-start/platform-contracts";
import { request } from "../../prototype/api/client.js";

export const fetchLoginStatus = () => request("/api/auth/session", oidcStatusSchema);
export const signOut = () => request("/api/auth/logout", oidcLogoutSchema, { method: "POST", body: "{}" });
